import React from 'react'
import CourtPopupView from './court-popup.view'
import { Observer } from 'mobx-react-lite'
import {useAppStore} from "../../../app/store";
import CourtPopupController from "../../interfaces/controllers/court-popup.controller";
import CourtPopupPresenter from "../../interfaces/presenters/court-popup.presenter";
import CourtEntity from "../../../courts/entities/court.entity";

const CourtPopupContainer: React.FC = () => {
  const store = useAppStore()
  const controller = new CourtPopupController(store)
  const presenter = new CourtPopupPresenter(store)

  const handleClose = () => {
    controller.closeModal()
  }

  const handleAddToFavorite = (court: CourtEntity) => {
    console.log('ADDING TO FAVORITE')
    controller.selectCourt(court)
    controller.addCourtToFavorite(true)
  }

  const handleViewInApp = (court: CourtEntity) => {
    console.log('VIEW IN MAP')
    controller.selectCourt(court)
    controller.addCourtToFavorite(false)
  }

  return (
    <Observer>
      {() => {
        return (
          <CourtPopupView
            isOpen={presenter.popupVisible()}
            onClose={handleClose}
            court={presenter.getCourt()}
            onAddToFavorites={handleAddToFavorite}
            onViewInApp={handleViewInApp}
          />
        )
      }}
    </Observer>
  )
}

export default CourtPopupContainer
